import { render, staticRenderFns } from "./ActivateNurseAccount.vue?vue&type=template&id=0867af19&scoped=true&"
import script from "./ActivateNurseAccount.vue?vue&type=script&lang=js&"
export * from "./ActivateNurseAccount.vue?vue&type=script&lang=js&"
import style0 from "./ActivateNurseAccount.vue?vue&type=style&index=0&id=0867af19&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0867af19",
  null
  
)

export default component.exports